export const VALUES = [
  {
    label: "TIMEPIECES YOU CAN TRUST",
    title: "Every Watch, Verified",
    desc: "Each timepiece in our collection undergoes a detailed authentication process by our in-house specialists. Movement and original components are all verified before any watch enters our showroom.",
  },
  {
    label: "CURATION",
    title: "A Considered Collection",
    desc: "We take pride in building a wide, high-quality inventory of luxury watches. Our store specializes in pieces that hold their value, exhibit fine craftsmanship, and carry the legacy of time-honored brands.",
  },
  {
    label: "PERSONALIZED SERVICE",
    title: "Personalized, Patient, Private",
    desc: "Wether you are buying your first luxuy watch or completing a long-held collection, we move at your pace. Appointments are tailored to your needs, and transparency is at the heart of everything we do.",
  },
  {
    label: "RELIABILITY",
    title: "Built Over a Decade",
    desc: "Since 2015, we have built our reputation one client at a time. The relationships we hold with collectors across Indonesia and the region are our most valuable assets, and we protect them accordingly.",
  },
];

export const MILESTONES = [
  {
    year: "2015",
    title: "Founded in Jakarta",
    desc: "Legacy Timepiece opens its first boutique with a focus on authenticated pre-owned luxury watches.",
  },
  {
    year: "2018",
    title: "Expanded Brand Roster",
    desc: "Added Patek Philippe, Audemars Piguet, and Vacheron Constantin to our regular inventory.",
  },
  {
    year: "2021",
    title: "Trade-In & Consignment",
    desc: "Launched formal trade-in and consignment programmes for collectors looking to refresh their collections.",
  },
  {
    year: "2024",
    title: "Plaza Blok M Boutique",
    desc: "Moved to our current flagship location at Plaza Blok M, designed for private, appointment-led viewings.",
  },
];
